import type { ToolMeta } from "../types";

export const toolMeta: ToolMeta = {
  slug: "dictate",
  title: "Dictate",
  description:
    "Dictate notes with the browser's speech tools, edit the transcript with session-based undo, and play text back aloud.",
  category: "Text",
};
